module.exports = __webpack_public_path__ + "f061d3029bf75f7ae18d48f070dcbdc9.png";